import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import cmsPageAPI from "../../api/cmsPageApi";
import SEO from "../../components/SEO";
import Breadcrump from "../../components/Breadcrump";

function ShippingDeliviryPolicy() {
  const location = useLocation();
  const path = location.pathname.split("/")[1];

  const [metaData, setMetaData] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchCMSDetails();
  }, [path]);

  const fetchCMSDetails = async () => {
    try {
      const res = await cmsPageAPI.details(path);

      if (res.code === 200) {
        const result = res.data;

        setTitle(result.title);
        setDescription(result.content);
        setMetaData(result?.meta);
      }
    } catch (err) {}
  };

  return (
    <>
      <SEO meta={metaData} />

      <Breadcrump title="Shipping & Delivery Policy " />

      <section className="terms-condition py-5">
        <div className="container">
          <div className="content text-dark">
            <div dangerouslySetInnerHTML={{ __html: description }} />
           <div className="shipping-policy-content">

  <p>
    Thank you for shopping with <strong>Nesha World</strong>.
  </p>

  <h5>Order Processing</h5>
  <ul>
    <li>Orders are typically processed within 1–3 business days after confirmation.</li>
    <li>Orders placed on weekends or public holidays will be processed on the next working day.</li>
    <li>During sales, festive seasons, or high-demand periods, processing times may be slightly longer.</li>
  </ul>

  <h5>Shipping Time</h5>
  <ul>
    <li>Standard delivery within India typically takes 7–10 business days, depending on the delivery location.</li>
    <li>
      Delivery timelines are estimates and may vary due to courier operations,
      weather conditions, public holidays, or other unforeseen circumstances.
    </li>
  </ul>

  <h5>Shipping Charges</h5>
  <ul>
    <li>Shipping charges, if applicable, will be displayed at checkout before payment.</li>
    <li>Free shipping offers, if any, will be clearly mentioned on the website.</li>
  </ul>

  <h5>Order Tracking</h5>
  <ul>
    <li>Once your order is dispatched, tracking details will be shared via email, SMS, or WhatsApp.</li>
    <li>Customers can use the tracking information to monitor their shipment status.</li>
  </ul>

  <h5>Delivery Attempts</h5>
  <ul>
    <li>Courier partners generally make multiple delivery attempts.</li>
    <li>
      If the customer is unavailable or provides an incorrect address,
      the order may be returned to us.
    </li>
  </ul>

  <h5>Incorrect Address Information</h5>
  <ul>
    <li>Customers are responsible for providing accurate shipping details.</li>
    <li>
      Nesha World will not be responsible for delays or non-delivery caused by
      incorrect or incomplete addresses provided by the customer.
    </li>
  </ul>

  <h5>Delayed Deliveries</h5>
  <p>
    While we strive to ensure timely delivery, Nesha World is not liable for
    delays caused by courier services, natural events, strikes, public holidays,
    transportation issues, or circumstances beyond our control.
  </p>

  <h5>Order Acceptance</h5>
  <p>
    Upon delivery, customers are advised to inspect the package before use.
    Any concerns regarding the order should be reported within 48 hours of delivery.
  </p>

  <h5>Contact Us</h5>
  <p>
    For shipping-related inquiries, please contact:
  </p>

  <ul className="list-unstyled">
    <li><strong>Email:</strong> care@neshaworld.com</li>
    <li><strong>WhatsApp:</strong> +91 9996150117</li>
  </ul>

</div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ShippingDeliviryPolicy;
